<template>
  <b-modal ref="trackingModal" title="Tracking" @shown="shown" hide-footer>
    <form @submit.prevent="submitRequest" style="padding:15px;">
      <div class="modal-body">
        <div class="form-group" v-if="tracked">
          <label for="tracking_number">Tracking Number</label>
          <input
            ref="tracking_number"
            :class="{
              'is-invalid': $v.tracking_number.$invalid && submit,
              'is-valid': !$v.tracking_number.$invalid && submit
            }"
            type="text"
            v-model="tracking_number"
            class="form-control"
            id="tracking_number"
            aria-describedby="tracking_number_help"
            placeholder="eg: A45465545646GB"
          />
          <div class="invalid-feedback" v-if="!$v.tracking_number.required">
            Please provide a valid tracking number
          </div>
          <div class="invalid-feedback" v-if="!$v.tracking_number.alphaNum">
            Only alpha numeric character are allowed
          </div>
        </div>

        <div class="form-group" v-if="BRAND == 'IM'">
          <label for="weight">Weight</label>
          <input
            ref="weight"
            :class="{
              'is-invalid': $v.weight.$invalid && submit,
              'is-valid': !$v.weight.$invalid && submit
            }"
            type="text"
            v-model="weight"
            class="form-control"
            id="weight"
            aria-describedby="shipping_method_help"
            placeholder="Weight"
          />
          <div class="invalid-feedback" v-if="!$v.weight.required">
            Please provide a weight
          </div>
          <div class="invalid-feedback" v-if="!$v.weight.numeric">
            Only digits are allowed
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="submit" class="btn btn-primary">Submit</button>
        <button type="dismiss" class="btn btn-light">Cancel</button>
      </div>
    </form>
  </b-modal>
</template>

<script>
import { required, numeric, alphaNum } from "vuelidate/lib/validators";
export default {
  name: "tracking-modal",
  props: ["tracked"],
  data() {
    return {
      tracking_number: "",
      weight: null,
      submit: false
    };
  },
  validations() {
    if (this.BRAND == "IM") {
      return {
        tracking_number: {
          required,
          alphaNum
        },
        weight: {
          required,
          numeric
        }
      };
    } else if (this.BRAND == "SM") {
      return {
        tracking_number: {
          required,
          alphaNum
        },
        weight: {}
      };
    } else if (this.BRAND == "EB") {
      return {
        tracking_number: {
          required,
          alphaNum
        },
        weight: {}
      };
    }
  },
  methods: {
    submitRequest(evt) {
      this.submit = true;
      evt.preventDefault();
      let trackingNumberValid = this.$v.tracking_number.$invalid;
      let weightValid = this.$v.weight.$invalid;
      let validFlag = this.tracked
        ? !trackingNumberValid && !weightValid
        : !weightValid;
      if (validFlag) {
        this.submit = false;
        this.$parent.shipOrder({
          trackingNumber: this.tracking_number,
          weight: this.weight
        });
      }
    },
    showModal() {
      this.$refs.trackingModal.show();
    },
    hideModal() {
      this.$refs.trackingModal.hide();
    },
    shown() {
      if (this.tracked) {
        this.$refs.tracking_number.focus();
      } else {
        this.$refs.weight.focus();
      }
    }
  }
};
</script>
